import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import commandsLibraryImage from "src/shared/assets/commandsLibrary.png";

export const CommandsLibrary: React.FC = () => {
  return (
    <Stack
      width={1}
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      gap={1}
    >
      <Stack
        width={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
        sx={{
          flexWrap: {
            sm: "nowrap",
            xs: "wrap",
          },
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          Commands
        </Typography>
        <Typography
          color="text.secondary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          library AND
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          SETTINGS
        </Typography>
      </Stack>

      <Typography
        maxWidth={0.7}
        color="text.primary"
        variant="body1"
        textAlign="center"
        sx={{
          fontSize: {
            sm: "1rem",
            xs: "0.875rem",
          },
        }}
      >
        Build your own shortcuts and configure core settings to tailor the
        experience to your workflow.
      </Typography>

      <Box width={1}>
        <img
          width="100%"
          src={commandsLibraryImage}
          alt="commandsLibraryImage"
        />
      </Box>
    </Stack>
  );
};
